var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"alert-bar"}},[_c('transition-group',{attrs:{"name":"slide-down","appear":""}},_vm._l((_vm.alerts),function(alert,index){return _c('notice',{key:index,class:alert.theme,attrs:{"closable":true},on:{"close":function($event){_vm.close(alert.text)}}},[_c('div',{domProps:{"innerHTML":_vm._s(alert.text)}})])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-697d65b9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/globals/AlertBar.vue
// module id = 372
// module chunks = 8